var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 200 200",
      "width": "200",
      "height": "200"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "100",
      "fill": "#2196F3"
    }
  }), _c('path', {
    attrs: {
      "d": "M100 0C155.228 0 200 44.772 200 100C200 155.228 155.228 200 100 200V0Z",
      "fill": "#1E7FCE"
    }
  }), _c('rect', {
    attrs: {
      "x": "46",
      "y": "108",
      "width": "88",
      "height": "36",
      "rx": "4",
      "fill": "#F4E3C3"
    }
  }), _c('rect', {
    attrs: {
      "x": "90",
      "y": "108",
      "width": "44",
      "height": "36",
      "rx": "4",
      "fill": "#FED8B2"
    }
  }), _c('rect', {
    attrs: {
      "x": "46",
      "y": "108",
      "width": "88",
      "height": "8",
      "fill": "#FFD15D"
    }
  }), _c('rect', {
    attrs: {
      "x": "88",
      "y": "116",
      "width": "4",
      "height": "20",
      "fill": "#F9B54C"
    }
  }), _c('rect', {
    attrs: {
      "x": "54",
      "y": "78",
      "width": "72",
      "height": "32",
      "rx": "4",
      "fill": "#F4E3C3"
    }
  }), _c('rect', {
    attrs: {
      "x": "90",
      "y": "78",
      "width": "36",
      "height": "32",
      "rx": "4",
      "fill": "#FED8B2"
    }
  }), _c('rect', {
    attrs: {
      "x": "54",
      "y": "78",
      "width": "72",
      "height": "8",
      "fill": "#FFD15D"
    }
  }), _c('rect', {
    attrs: {
      "x": "88",
      "y": "86",
      "width": "4",
      "height": "16",
      "fill": "#F9B54C"
    }
  }), _c('rect', {
    attrs: {
      "x": "62",
      "y": "52",
      "width": "56",
      "height": "28",
      "rx": "4",
      "fill": "#F4E3C3"
    }
  }), _c('rect', {
    attrs: {
      "x": "90",
      "y": "52",
      "width": "28",
      "height": "28",
      "rx": "4",
      "fill": "#FED8B2"
    }
  }), _c('rect', {
    attrs: {
      "x": "62",
      "y": "52",
      "width": "56",
      "height": "8",
      "fill": "#FFD15D"
    }
  }), _c('rect', {
    attrs: {
      "x": "88",
      "y": "60",
      "width": "4",
      "height": "12",
      "fill": "#F9B54C"
    }
  }), _c('circle', {
    attrs: {
      "cx": "142",
      "cy": "142",
      "r": "34",
      "fill": "#FFC727"
    }
  }), _c('circle', {
    attrs: {
      "cx": "142",
      "cy": "142",
      "r": "26",
      "fill": "#FFF3C4"
    }
  }), _c('path', {
    attrs: {
      "d": "M142 116A26 26 0 1 1 123.61 157.39",
      "fill": "none",
      "stroke": "#F4A200",
      "stroke-width": "10",
      "stroke-linecap": "round"
    }
  }), _c('circle', {
    attrs: {
      "cx": "142",
      "cy": "142",
      "r": "12",
      "fill": "#FFC727"
    }
  }), _c('text', {
    attrs: {
      "x": "142",
      "y": "147",
      "text-anchor": "middle",
      "font-size": "14",
      "font-weight": "700",
      "font-family": "Inter, sans-serif",
      "fill": "#324A5E"
    }
  }, [_vm._v("%")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }